/**
 * Pick the preferred membership (or platform account) and patch current_account / is_admin.
 *
 * @param {object|false|null} user
 * @param {number|string|null} preferredAccountId
 * @param {Array<object>} [platformAccounts]
 * @returns {object|false|null}
 */
export function resolveAccountContext(user, preferredAccountId, platformAccounts = []) {
  if (!user || typeof user !== 'object') {
    return user;
  }

  const memberships = Array.isArray(user.accounts) ? user.accounts : [];
  const platform = Array.isArray(platformAccounts) ? platformAccounts : [];
  const preferredId = preferredAccountId != null ? Number(preferredAccountId) : null;
  const isPlatformAdmin = !!user.is_platform_admin;

  let current = null;

  if (preferredId != null) {
    current = memberships.find((account) => Number(account.id) === preferredId) || null;
    if (!current && isPlatformAdmin) {
      const fromPlatform = platform.find((account) => Number(account.id) === preferredId);
      if (fromPlatform) {
        current = {
          ...fromPlatform,
          role: fromPlatform.role || 'platform',
        };
      }
    }
  }

  if (!current) {
    current = user.current_account || memberships[0] || null;
  }

  if (!current && isPlatformAdmin && platform.length) {
    const first = platform[0];
    current = {
      ...first,
      role: first.role || 'platform',
    };
  }

  const role = current && current.role ? current.role : null;
  const membershipAdmin = role === 'owner' || role === 'admin';
  const isAdmin = current
    ? membershipAdmin || isPlatformAdmin
    : false;

  return {
    ...user,
    current_account: current,
    is_admin: isAdmin,
  };
}
